/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCircuitCapacitorPolarized = createReactComponent("outline", "circuit-capacitor-polarized", "IconCircuitCapacitorPolarized", [["path", { "d": "M22 12h-8", "key": "svg-0" }], ["path", { "d": "M2 12h8", "key": "svg-1" }], ["path", { "d": "M10 7v10", "key": "svg-2" }], ["path", { "d": "M14 7v10", "key": "svg-3" }], ["path", { "d": "M17 5h4", "key": "svg-4" }], ["path", { "d": "M19 3v4", "key": "svg-5" }]]);

export { IconCircuitCapacitorPolarized as default };
//# sourceMappingURL=IconCircuitCapacitorPolarized.mjs.map
